module.exports = __webpack_public_path__ + "img/deepseek-send@3x.d5777af4.png";